import './form-check.scss';
import { useLayoutEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { FormCheckBaseProps, formCheckClassName } from './form-check-utils';

interface CheckboxProps extends FormCheckBaseProps {
  indeterminate?: boolean;
}

export const Checkbox = ({
  indeterminate = false,
  className,
  size,
  background,
  ...passthrough
}: CheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <Form.Check
      {...passthrough}
      type='checkbox'
      ref={inputRef}
      className={formCheckClassName({ size, background }, className)}
    />
  );
};
